
   
        <router-outlet></router-outlet>


  <ngx-spinner bdColor="rgba(255,255,255,0.6)" size="large" color="#25476d" type="ball-clip-rotate-multiple"
    [fullScreen]="true">
  </ngx-spinner>
  